module.exports = __webpack_public_path__ + "static/media/icon-push-to-store.583913e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icon-push-to-store.svg
// module id = 2941
// module chunks = 0